import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({ component: Index });

export function Index() {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
}
